import { render, staticRenderFns } from "./VideoReports-Preview.vue?vue&type=template&id=61480961&scoped=true"
import script from "./VideoReports-Preview.js?vue&type=script&lang=js&external"
export * from "./VideoReports-Preview.js?vue&type=script&lang=js&external"
import style0 from "./VideoReports-Preview.vue?vue&type=style&index=0&id=61480961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61480961",
  null
  
)

export default component.exports